import React, { lazy, useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import AppFrameworkContext from '../../contexts/app-framework';
import { ThemeProvider } from '@carvana/showroom-theme';
import { ThemeProvider as AnotherThemeProvider } from '@carvana/theme';
import { CheckboxNext } from '~/library/styles/src';
import ModalContext from '../../contexts/modals';
import Modal from '../../../modals';

const ExampleModal = lazy(() =>
  import(/* webpackChunkName: "example-example-modal" */ './example-modal')
);

const ErrorModal = lazy(() =>
  import(/* webpackChunkName: "example-error-modal" */ './error-modal')
);

const useExampleVm = () => {
  const { load, submit } = useContext(AppFrameworkContext);
  const {
    isExampleModalShown,
    setExampleModalOpen,
    isErrorModalShown,
    setErrorModalOpen
  } = useContext(ModalContext);
  const { search } = useLocation();
  const [message, setMessage] = useState(null as null | string);

  useEffect(() => {
    load(
      new Promise<void>((resolve, reject) => {
        setTimeout(() => {
          if (search.includes('loadError=true')) {
            reject('Example Error');
          } else {
            setMessage('Hello World');
            resolve();
          }
        }, 3000);
      })
    );
  }, []);

  const onSubmit = (submitError: boolean) => {
    submit(
      new Promise<void>((resolve, reject) => {
        setTimeout(() => {
          if (submitError) {
            reject('Example Error');
          } else {
            resolve();
          }
        }, 3000);
      })
    );
  };

  return {
    message,
    onSubmit,
    setExampleModalOpen,
    setErrorModalOpen,
    isErrorModalShown,
    isExampleModalShown
  };
};

const Example: React.FC = () => {
  const {
    message,
    onSubmit,
    isExampleModalShown,
    setExampleModalOpen,
    isErrorModalShown,
    setErrorModalOpen
  } = useExampleVm();
  const [submitError, setSubmitError] = useState(false);

  return (
    <AnotherThemeProvider>
      <ThemeProvider>
        <div>{message}</div>
        <CheckboxNext
          text="Submit Error?"
          value={submitError}
          onChange={() => setSubmitError(!submitError)}
        />
        <Button
          isPrimaryCta={true}
          onClick={() => {
            debugger;
            onSubmit(submitError);
          }}
          text="Save & Continue"
          hierarchyType="primary"
          size="large"
          color="blue"
          icon="none"
        />
        <Button
          text="Show Modal"
          onClick={() => setExampleModalOpen(true)}
          hierarchyType="secondary"
          size="large"
          color="blue"
          icon="none"
        />
        <Button
          text="Show Error Modal"
          onClick={() => setErrorModalOpen(true)}
          hierarchyType="secondary"
          size="large"
          color="blue"
          icon="none"
        />
        <Modal
          open={isExampleModalShown}
          modalTestName={'Example'}
          onClose={() => setExampleModalOpen(false)}
        >
          <ExampleModal />
        </Modal>
        <Modal
          open={isErrorModalShown}
          modalTestName={'Error'}
          onClose={() => setErrorModalOpen(false)}
        >
          <ErrorModal />
        </Modal>
      </ThemeProvider>
    </AnotherThemeProvider>
  );
};

export default Example;
